import Aos from 'aos';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const Contact = () => {
  const location = useLocation();

  // State to handle form data and validation errors
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [errors, setErrors] = useState({
    name: '',
    email: '',
    message: ''
  });

  // Initialize AOS animations
  useEffect(() => {
    Aos.init();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    // Name validation
    if (!formData.name) {
      newErrors.name = 'Name is required';
      isValid = false;
    }

    // Email validation
    if (!formData.email) {
      newErrors.email = 'Email is required';
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email address is invalid';
      isValid = false;
    }

    // Message validation
    if (!formData.message) {
      newErrors.message = 'Message is required';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    
    if (validateForm()) {
      alert('Your message was successfully sent!');
      // Reset form after successful submission
      setFormData({ name: '', email: '', message: '' });
      setErrors({});
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <>
      <div className={location.pathname !== '/single' ? "outer" : ""} id="contact" data-aos="fade-up" data-aos-duration="1200" data-aos-easing="ease-in-quad">
        <div className="contact-outer" data-aos="fade-up" data-aos-duration="1200" data-aos-easing="ease-in-quad">
          <div className="container">
            <div className="contact-inner" data-aos="fade-up" data-aos-duration="1200" data-aos-easing="ease-in-quad">
              <div className="heading" data-aos="fade-up" data-aos-duration="1200" data-aos-easing="ease-in-quad">
                <h2><span className="line"></span> Contact Us <span className="line"></span></h2>
                <p>I thrive on turning complex problems into simple, beautiful <br />solutions that enhance user satisfaction.</p>
              </div>

              <div className="contact-info" data-aos="fade-up" data-aos-duration="1200" data-aos-easing="ease-in-quad">
                <div className="row">
                  <div className="col-sm-4 col-12" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-quad">
                    <div className="img-content">
                      <img src="assets/Images/email.png" alt="" />
                    </div>
                    <p>abctract@gmail.com</p>
                  </div>
                  <div className="col-sm-4 col-12" data-aos="fade-up" data-aos-duration="1100" data-aos-easing="ease-in-quad">
                    <div className="img-content">
                      <img src="assets/Images/call.png" alt="" />
                    </div>
                    <p>+91 9000 000 000</p>
                  </div>
                  <div className="col-sm-4 col-12" data-aos="fade-up" data-aos-duration="1200" data-aos-easing="ease-in-quad">
                    <div className="img-content">
                      <img src="assets/Images/map.png" alt="" />
                    </div>
                    <p>Surat, Gujarat -395002</p>
                  </div>
                </div>
              </div>

              <form onSubmit={handleSubmit} data-aos="fade-up" data-aos-duration="1200" data-aos-easing="ease-in-quad">
                <div className="row">
                  <div className="col-md-6 col-12" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-quad">
                    <div className="inputgroup">
                      <label>Name</label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Enter Your Name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                      {errors.name && <p className="error">{errors.name}</p>}
                    </div>
                  </div>

                  <div className="col-md-6 col-12" data-aos="fade-up" data-aos-duration="1100" data-aos-easing="ease-in-quad">
                    <div className="inputgroup">
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter Your Email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {errors.email && <p className="error">{errors.email}</p>}
                    </div>
                  </div>

                  <div className="col-12" data-aos="fade-up" data-aos-duration="1200" data-aos-easing="ease-in-quad">
                    <div className="inputgroup">
                      <label>Message</label>
                      <textarea
                        name="message"
                        placeholder="Enter Your Message"
                        value={formData.message}
                        onChange={handleChange}
                      ></textarea>
                      {errors.message && <p className="error">{errors.message}</p>}
                    </div>
                  </div>

                  <div className="col-12" data-aos="fade-up" data-aos-duration="0000" data-aos-easing="ease-in-quad">
                    <div className="button-group">
                      <button type="submit" className="button">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
